/*
 * B2B minimum-order rule (Phase 3, Task 6) — toggle-only, B2B-gated by markup.
 * Server-side Liquid renders the correct initial state (notice + disabled checkout).
 * This script keeps it live on cart changes WITHOUT ever touching quantities or
 * calling a destructive cart API — it only reads /cart.js (GET) and toggles the
 * notice visibility + the checkout button's disabled state. Safe by construction.
 */
(function () {
  if (window.__customB2bMinOrder) return;
  window.__customB2bMinOrder = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function apply(total) {
    var notices = document.querySelectorAll('[data-min-order-notice]');
    if (!notices.length) return; // not a B2B buyer / no notice on page
    var min = parseInt(notices[0].getAttribute('data-minimum-quantity'), 10) || 0;
    var below = min > 0 && total > 0 && total < min;

    notices.forEach(function (n) {
      n.hidden = !below;
      var cur = n.querySelector('[data-min-order-current]');
      if (cur) cur.textContent = total;
    });
    document.querySelectorAll('[data-b2b-checkout]').forEach(function (btn) {
      if (below) btn.setAttribute('disabled', '');
      else btn.removeAttribute('disabled');
    });
  }

  function refresh() {
    if (!document.querySelector('[data-min-order-notice]')) return;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { apply(c.item_count); })
      .catch(function () {});
  }

  ['cart:refresh', 'line-item:change:end', 'cart:item-added', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(refresh, 150); });
  });

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);
})();
